module.exports = __webpack_public_path__ + "img/dragon_shell_hatching.b20fb19b.jpg";